import ModuleCard from "./ModuleCard";
export default ModuleCard;
